// THE REGISTER'S SIGN-OFF STAR (owner, 2026-10-10: "show the stars in the
// shop drawing register too"). The same star the Gantt draws for the
// drawing's activity: green = signed off, red = past its sign-off date,
// gold = pending; and a grey one where a moved sign-off was first planned.
// Pure, so the colours are tested without the table.

export const STAR_COLOR = { signed: "#2e7d32", overdue: "#c62828", pending: "#d9a400", original: "#b0b0b0" };

/** null when the activity has no sign-off date and none was given. */
export function signOffStar(r, today) {
  if (!r) return null;
  const was = r.signOffDateOriginal && r.signOffDateOriginal !== r.signOffDate ? r.signOffDateOriginal : null;
  if (r.signedOff) return { kind: "signed", glyph: "★", color: STAR_COLOR.signed, date: r.signedOffAt, was };
  if (!r.signOffDate) return null;
  const late = !!today && r.signOffDate < today;
  return { kind: late ? "overdue" : "pending", glyph: "☆", color: late ? STAR_COLOR.overdue : STAR_COLOR.pending, date: r.signOffDate, was };
}
